import * as Sentry from '@sentry/react';
import config from './app/config/app.config';
import { getEnvironment } from './app/utils/env';

Sentry.init({
  dsn: config.sentry.dsn,
  enabled: config.sentry.enabled,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  sendDefaultPii: true,
  environment: getEnvironment(),
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true
});